import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logout } from './../../actions/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { padZero } from './../../utils';
import CheckApi from './../master-data/checkapi';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',]

class Titlebar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            interval: setInterval(() => { this.setState({ date: new Date() }) }, 1000),
            userName: this.props.username,
            hide: true
        }
    }

    getUTCDateTime(date) {
        return `${padZero(date.getUTCDate())}-${MONTHS[date.getUTCMonth()]}-${date.getUTCFullYear()}\
        ${padZero(date.getUTCHours())}:${padZero(date.getUTCMinutes())}:${padZero(date.getUTCSeconds())}`;
    }

    getLocalDateTime(date) {
        return `${padZero(date.getDate())}-${MONTHS[date.getMonth()]}-${date.getFullYear()}\
        ${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())}`;
    }

    componentWillUnmount() {
        clearInterval(this.state.interval);
    }

    render() {
        let utc = this.getUTCDateTime(this.state.date);
        let ist = this.getLocalDateTime(this.state.date);

        return (
            <>
            <div className='d-flex'
                style={{ height: '3rem' }}>
                <div className='flex-grow-1 overflow-hidden'>
                    <img className='h-100'
                        src='/img/logo.svg'
                        alt='SpiceJet-logo' />
                </div>
                <div className='d-flex align-items-center mx-2'>
                    <table className='small'>
                        <tbody>
                            <tr>
                                <th className='text-right pr-1'
                                    scope='row'>UTC</th>
                                <td className='text-nowrap'>{utc}</td>
                            </tr>
                            <tr>
                                <th className='text-right pr-1'
                                    scope='row'>IST</th>
                                <td className='text-nowrap'>{ist}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className='mx-3'>
                        <span className='small text-nowrap'>{this.props.username}</span>
                    </div>
                    <div>
                        <button className='btn btn-light btn-sm'
                            onClick={this.props.logout}
                            title='Logout'>
                            <FontAwesomeIcon icon={faPowerOff} />
                        </button>
                    </div>
                </div>
            </div >
            
            {/* <CheckApi username={this.state.userName}  style={{diplay : this.state.hide ? "none" : "none"}}  /> */}
        </>
        );
    }
}

const mapStateToProps = state => ({});

const mapActionsToProps = { logout, };

export default connect(mapStateToProps, mapActionsToProps)(Titlebar);